import { render } from "./PictureImg.vue?vue&type=template&id=5ce5b40a&scoped=true&ts=true"
import script from "./PictureImg.vue?vue&type=script&lang=ts"
export * from "./PictureImg.vue?vue&type=script&lang=ts"

import "./PictureImg.vue?vue&type=style&index=0&id=5ce5b40a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce5b40a"]])

export default __exports__